import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  canonicalDevtoolsUrl,
  COLATOOL_ORIGIN,
  COLATOOL_SITE_NAME,
  DEFAULT_SEO,
} from '../config/siteSeo';

function upsertMeta(
  attribute: 'name' | 'property',
  key: string,
  content: string,
) {
  let el = document.querySelector(
    `meta[${attribute}="${key}"]`,
  ) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

function upsertLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

export default function ColaToolSeo() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const description = t('seo.description', { defaultValue: DEFAULT_SEO.description });
    const keywords = t('seo.keywords', { defaultValue: DEFAULT_SEO.keywords });
    const pageUrl = canonicalDevtoolsUrl(location.pathname);
    const ogImage = `${COLATOOL_ORIGIN}/devtools/favicon.ico`;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertLink('canonical', pageUrl);

    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', COLATOOL_SITE_NAME);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', pageUrl);
    upsertMeta('property', 'og:image', ogImage);
    upsertMeta('property', 'og:title', document.title);

    upsertMeta('name', 'twitter:card', 'summary');
    upsertMeta('name', 'twitter:title', document.title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', ogImage);
  }, [t, location.pathname]);

  return null;
}
